export default __webpack_public_path__ + "static/media/template-preview.a297fe17.png";